<template>
  <app-page title="Impact" icon="chart-line" class="analytics-benchmark">
    <template #custom-content>
      <b-col>
        <analytics-nav />
        <industry-comparison-section :metrics="metrics" :sector="sector" :loading="loading" />
        <workforce-impact-section :metrics="metrics" :sector="sector" :loading="loading" />
        <benchmark-metrics />
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import ApiClient from '@/ApiClient';
import AppPage from '@/components/AppPage.vue';
import BenchmarkMetrics from '@/pages/analyticsBenchmark/components/BenchmarkMetrics.vue';
import IndustryComparisonSection from '@/pages/analyticsBenchmark/components/IndustryComparisonSection.vue';
import WorkforceImpactSection from '@/pages/analyticsBenchmark/components/WorkforceImpactSection.vue';
import AnalyticsNav from '@/pages/analyticsHomepage/components/AnalyticsNav.vue';

const loading = ref(true);
const sector = ref(null);
const metrics = ref([]);

const fetchData = async () => {
  loading.value = true;
  try {
    const data = await ApiClient.getSectorBenchmarks();
    sector.value = data?.sector || null;
    metrics.value = data?.metrics || [];
  } catch (error) {
    console.error('Failed to fetch sector benchmarks:', error);
  }
  loading.value = false;
};

onBeforeMount(() => fetchData());
</script>
